import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterSubEntities'
})
export class FilterSubEntitiesPipe implements PipeTransform {
  transform(entities: any[], searchValue: string, subEntityName?: string, subEntityKey?: string): any[] {
    if (!searchValue || (searchValue && searchValue.trim() == "")) {
      return entities; // Return the original array if there's no search value
    }

    const lowercaseSearch = searchValue.toLowerCase();

    return entities.filter((entity) => {
      const nameOrLabel = (entity.category && entity.name ? entity.category + ' ' + entity.name : null) || entity.referenceName || entity.name || entity.label
        || entity.nom || entity.category || entity.fullName || entity.fullname || entity.firstName || entity.lastName || entity.title
        || entity.libelle || entity.nomComplet || entity.nomSociete || entity || entity.value || entity.ceeOperationFiles[0]?.name;
    
      let nameSubEntity = "";
      if (subEntityName && subEntityKey) {
        const subEntity = entity[subEntityName];
        if (Array.isArray(subEntity) && subEntity.length > 0) {
          const firstWithValue = subEntity.find(
            (item) => item && item[subEntityKey] && item[subEntityKey].toString().trim() !== ""
          );
          nameSubEntity = firstWithValue ? firstWithValue[subEntityKey] : "";
        } else if (subEntity && typeof subEntity === "object") {
          nameSubEntity = subEntity[subEntityKey] || "";
        }
      }

      if (nameOrLabel && typeof nameOrLabel === 'string') {
        const lowercaseNameOrLabel = this.removeSpecialFrenshChars(nameOrLabel.toLowerCase());
        const lowercaseSubEntityNameOrLabel = this.removeSpecialFrenshChars(nameSubEntity.toLowerCase());
        return lowercaseNameOrLabel.includes(this.removeSpecialFrenshChars(lowercaseSearch)) || lowercaseSubEntityNameOrLabel.includes(this.removeSpecialFrenshChars(lowercaseSearch));
      }

      return entities;
    });
  }

  removeSpecialFrenshChars(str: string): string {
    let normalizedStr = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    // Replace '-' with ' '
    normalizedStr = normalizedStr.replace(/-/g, ' ');

    return normalizedStr;
  }
}